import React from 'react';

export default function BigDownloadButton() {
  return (
    <div className="bg-white text-black rounded-[50%] text-center flex items-center justify-center gap-1 w-[186px] h-[79px] uppercase tracking-[0.39px] text-[13px] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] pointer-events-none opacity-0 group-hover:opacity-80">
      DOWNLOAD AT <img src="/assets/images/dts-logo-black.svg" alt="DTS logo" width="40" />
    </div>
  );
}
